import styled from 'styled-components'
import { SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'
import { COLOR } from 'ggx-componentlibrary/design/color/color.constants'
import {
  FONT_SIZE,
  FONT_REGULAR,
  LINE_HEIGHT,
} from 'ggx-componentlibrary/design/typography/typography.constants'
import { InputStyles } from 'ggx-componentlibrary/components/text-field/text-field.component.styles'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`

const StyleHelper = styled(SmallText)`
  display: inline-block;
  position: absolute;
  margin: 0;
  text-align: right;
  width: 50px;
  right: 17px;
  bottom: 14px;
`

const StyledTextArea = styled.textarea`
  ${InputStyles}
  ${FONT_REGULAR}
  font-size: ${FONT_SIZE.MEDIUM};
  line-height: ${LINE_HEIGHT.MEDIUM};
  color: ${COLOR.BLACK};
  white-space: pre-line;
  padding: 12px 16px;
  height: auto;
  resize: none;
  width: 100%;
  ${props => (props.error ? `caret-color: ${COLOR.RED_MEDIUM};` : '')}
  &.mimicker {
    overflow-wrap: break-word;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    visibility: hidden;
  }
    &.mimicker br {
  line-height: ${LINE_HEIGHT.MEDIUM};
    }
`

export { Container, StyleHelper, StyledTextArea }
